import { formatPhoneNumber } from 'platform/form-renderer/util';
import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import {
  getProfilePrefillEmail,
  getProfilePrefillPhone,
} from '../../utils/helpers';
import PrefillConfirmationReview from './PrefillConfirmationReview';

const PHONE_LABEL = content['sponsor--prefill-contact-phone-review-label'];
const EMAIL_LABEL = content['sponsor--prefill-contact-email-review-label'];

const SponsorContactInfoPrefillReview = ({ formData, ...props }) => (
  <PrefillConfirmationReview
    {...props}
    rows={[
      {
        label: PHONE_LABEL,
        value: formatPhoneNumber(getProfilePrefillPhone(formData) ?? ''),
      },
      { label: EMAIL_LABEL, value: getProfilePrefillEmail(formData) },
    ]}
  />
);

SponsorContactInfoPrefillReview.propTypes = {
  formData: PropTypes.object,
};

export default SponsorContactInfoPrefillReview;
